import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  public loadingStatus: boolean = false;
  constructor() {}

  public initLoading() {
    this.loadingStatus = true;
  }
  public endLoading() {
    this.loadingStatus = false;
  }
}
